



































































































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { ImagePreview } from 'vant'

const reportSalesModule = namespace('reportSales')

@Component({
  components: {}
})
export default class Form extends Vue {
  @reportSalesModule.State('reportInfo') reportInfo!: any

  fileList: any = []
  activeStatus: string = ''
  show: boolean = false
  rejectedDetail: string = ''

  mounted() {
    ;(this as any).activeStatus = this.$route.query.active || ''
    this.getData()
  }

  async setRecordInfoRevoke() {
    const { error, success }: any = await this.$request('REPORT_INFO_RESOLVE', {
      id: this.$route.query.id
    })
    if (success) {
      this.$router.push({ path: '/reviewSales' })
    } else {
      this.$notify(success.message || error.message)
    }
  }
  async setRecordInfoReject() {
    const { error, success }: any = await this.$request('REPORT_INFO_REJECT', {
      id: this.$route.query.id,
      rejectedDetail: this.rejectedDetail
    })
    if (success) {
      this.$router.push({ path: '/reviewSales' })
    } else {
      this.$notify(success.message || error.message)
    }
  }
  async getData() {
    const { success } = await this.$store.dispatch(
      'reportSales/getReportInfo',
      {
        id: this.$route.query.id
      }
    )
  }

  handleBackClick() {
    this.show = true
  }

  handleSaveClick() {
    ;(this as any).$dialog
      .confirm({
        title: '确认通过',
        message: '已核对清楚，并同意通过！'
      })
      .then(() => {
        // on confirm
        this.setRecordInfoRevoke()
      })
      .catch(() => {
        // on cancel
      })
  }

  handleBackSaveClick() {
    if (this.rejectedDetail.trim() === '') {
      this.$notify('填写驳回理由')
    } else {
      this.setRecordInfoReject()
    }
  }
  ImgClick(urls: any) {
    console.log(urls)
    let arr: any = []
    urls &&
      urls.forEach((item: any) => {
        arr.push(item.url)
      })
    ImagePreview(arr)
  }
}
